import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ allowedRole }) {
  const { isAuthenticated, role, authReady } = useAuth();

  if (!authReady) return null;

  if (!isAuthenticated) {
    return <Navigate to="/manager/login" replace />;
  }

  if (allowedRole && role !== allowedRole) {
    return <Navigate to={`/${role}/dashboard`} replace />;
  }

  return <Outlet />;
}
